<template>
	<v-icon :size="16">{{ icon }}</v-icon>
</template>

<script lang="ts">
	import {Component, Prop, Vue} from 'vue-property-decorator';
	import BooleanHelper from "@/helpers/BooleanHelper";

	@Component({})
	export default class AsiBooleanIcon extends Vue {

		@Prop({type: Boolean, required: true})
		public value!: boolean;

		private get icon(): string {
			return BooleanHelper.booleanToIcon(this.value);
		}
	}
</script>

<style scoped lang="scss">


</style>
